import { LegacyRef } from "react";

const LoggedInDocumentForm = ({
  formRef,
  linkToSign,
  token,
}: {
  formRef: LegacyRef<HTMLFormElement>;
  linkToSign?: string;
  token?: string;
}) => {
  return (
    <form
      target="_blank"
      id="token"
      ref={formRef}
      method="POST"
      action={`${linkToSign}`}
    >
      <input type="hidden" name="access_token" value={token} />
    </form>
  );
};

export default LoggedInDocumentForm;
